class TextListItemService {
    constructor() {
        this.index = 1;
    }

    /**
     * @function addToIndex
     * @description Adds to index
     */
    addToIndex() {
        this.index = this.index + 1;
    }

    /**
     * @function resetIndex
     * @description Resets index
     */
    resetIndex() {
        this.index = 1;
    }

    // Getters

    /**
     * @function getIndex
     * @description Gets index
     */
    getIndex() {
        return this.index;
    }
}

export default new TextListItemService();
